import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
import Tracker from '@evidentid/tracker';

import SendDocumentRequestProcedure from '@/modules/entity-request/procedures/SendDocumentRequestProcedure.vue';

// Store state/actions live in ./store (Pinia) now; the tracking/logging the
// module builder used to wire through app.observer.onMutation() hooks is
// inlined in the store's actions. Only the procedure registration remains.
export const entityRequestModule = createModuleBuilder()
    .demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .registerProcedures<{
    openSendDocumentRequestProcedure: { rpName: string, entities: Entity[] };
}>({
        openSendDocumentRequestProcedure: SendDocumentRequestProcedure,
    })
    .end();
